import React from 'react';
import QRCode from 'qrcode.react';
import "./DRMPlanOne.css"
import CryptoJS from 'crypto-js';
import { getFrontendBaseUrl } from '../../utils/getFrontendUrl';

function encryptParam(data, key) {
    return CryptoJS.AES.encrypt(data, key).toString();
}

function createEncryptedUrl(meetingdetails, key) {
    const frontendBaseUrl = getFrontendBaseUrl();
    
    if (!meetingdetails?.Id) {
        return '';
    }
    
    let encryptedId = encryptParam(meetingdetails?.Id, key);
    let url = `${frontendBaseUrl}/DRMAutoRouter/?id=${encodeURIComponent(encryptedId)}`;

    return url;
}

const QRCodeGenerator = ({meetingdetails}) => {

    const secretKey = 'ThisIsASecretKey';
    const encryptedUrl = createEncryptedUrl(meetingdetails, secretKey);

    if (!encryptedUrl || !meetingdetails?.Id) {
        return (
            <div className='QrCode' style={{
                padding: '20px',
                background: '#ffebee',
                border: '2px solid #f44336',
                borderRadius: '8px',
                color: '#c62828',
                textAlign: 'center'
            }}>
                <strong>⚠️ Cannot Generate QR Code</strong><br/>
                <small>Meeting ID is missing. Please save the meeting first.</small>
            </div>
        );
    }

    return ( <>
        <div className='QrCode'>
        <QRCode className='QrImage' value={encryptedUrl} />
        </div>  
       
    </> );
}
 
export default QRCodeGenerator;